export var standardTheme = {
    backgroundColor: "rgba(0,0,0,1)",
    surfaceColor: "rgba(1,1,1,1)",
    textColor: "white"
};
